// frontend/src/pages/root/index.tsx
import { createBrowserRouter, Navigate } from "react-router-dom";
import React from "react";
import Home from "../home/Home";
import Layout from "../../components/layout";
import AuthSuccess from "../auth/authSuccess";
import LoginModal from "../../components/login";
import Contact from "../../components/contact";
import GalleryHome from "../GalleryHome/GalleryHome";
import SeriesPage from "../SeriesPage/SeriesPage";
import AdminLayout from "../../components/AdminLayout";
import ProductDetailPage from "../../components/ProductDetailPage";
import UserEnquiriesComponent from "../../components/UserEnquiryList";
import DiscountProductPage from "../DiscountPage";
import { ScrollToTopWrapper } from "../../utility/scrollToTop";
import WishlistPage from "../WishlistPage";
import UserProfile from "../../components/UserProfilePage";
import CartPage from "../../components/CartPage";
import NotFound from "../../components/NotFound";

export const router = createBrowserRouter([
  {
    path: "/admin-panel",
    element: <AdminLayout />,
  },
  {
    path: "/cart",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <CartPage />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/profile",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <UserProfile />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <Home />
        </Layout>
      </ScrollToTopWrapper>
    ),
    errorElement: <NotFound />,
  },
  {
    path: "/enquiries",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <UserEnquiriesComponent />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/contact",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <Contact />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/auth/success",
    element: <AuthSuccess />,
  },
  {
    path: "/login",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <LoginModal />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/gallery",
    element: (
      <ScrollToTopWrapper scrollToHeight={0}>
        <Layout>
          <GalleryHome />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/series/:seriesId",
    element: (
      <ScrollToTopWrapper scrollToHeight={110}>
        <Layout>
          <SeriesPage />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/series/:seriesId/product/:productId",
    element: (
      <ScrollToTopWrapper scrollToHeight={0}>
        <Layout>
          <ProductDetailPage />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/discounts",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <DiscountProductPage />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  {
    path: "/wishlist",
    element: (
      <ScrollToTopWrapper>
        <Layout>
          <WishlistPage />
        </Layout>
      </ScrollToTopWrapper>
    ),
  },
  // Redirect undefined routes
  {
    path: "/series/undefined",
    element: <Navigate to="/gallery" replace />,
  },

  // Catch all 404 routes
  // {
  //   path: "*",
  //   element: <NotFound />,
  // },
]);
